<template>
    <el-drawer
        title="活动数据"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <template v-if="detailData">
                <el-card header="活动数据">
                    <el-row :gutter="40">
                        <!-- <el-col :span="6">
                            <p class="num">{{detailData.couponNum}}</p>
                            <p class="color-info">活动总数</p>
                        </el-col> -->
                        <el-col :span="8">
                            <p class="num">{{detailData.userTotalNum}}</p>
                            <p class="color-info">用户总数</p>
                        </el-col>
                        <el-col :span="8">
                            <p class="num">{{detailData.newUserTotalNum}}</p>
                            <p class="color-info">新用户数</p>
                        </el-col>
                        <el-col :span="8">
                            <p class="num">{{(detailData.newUserRate * 100).toFixed(2)}}%</p>
                            <p class="color-info">新用户转化率</p>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card header="用户数据" class="MT10">
                    <el-table :data="[detailData]" size="mini">
                        <el-table-column label="发起活动用户数据">
                            <el-table-column prop="userLaunchTotalNum" label="用户总数"></el-table-column>
                            <el-table-column prop="newLaunchUserTotalNum" label="新用户数"></el-table-column>
                            <el-table-column prop="newLaunchUserRate" label="新用户转化率" min-width="100">
                                <template slot-scope="scope">{{scope.row.newLaunchUserRate * 100}}%</template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="参与活动用户数据">
                            <el-table-column prop="userJoinTotalNum" label="用户总数"></el-table-column>
                            <el-table-column prop="newJoinUserTotalNum" label="新用户数"></el-table-column>
                            <el-table-column prop="newJoinUserRate" label="新用户转化率" min-width="100">
                                <template slot-scope="scope">{{scope.row.newJoinUserRate * 100}}%</template>
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </el-card>
                <el-card header="优惠券发放情况" class="MT10">
                    <el-row :gutter="40">
                        <el-col :span="12">
                            <p class="num">￥{{detailData.couponPrice}}</p>
                            <p class="color-info">优惠券总金额</p>
                        </el-col>
                        <el-col :span="12">
                            <p class="num">{{detailData.couponNum}}</p>
                            <p class="color-info">优惠券张数</p>
                        </el-col>
                    </el-row>
                </el-card>
            </template>
        </div>
        <div class="drawer-footer">
            <el-button type="primary" @click="close">确 认</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data(){
        return{
            id: "",
            drawerShow: false,
            detailData: null,
            dataLoading: false,
        }
    },
    methods:{
        show(id){
            this.id = id;
            this.getDetailData();
            this.drawerShow = true;
        },
        close(){
            this.detailData = null;
            this.drawerShow = false;
        },
        getDetailData(){
            this.dataLoading = true;
            this.$request({
                url: "/expand/statistics",
                method: "POST",
                params: {
                    id: this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.detailData = result;
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.dataLoading = false;
			});
        }
    }
}
</script>

<style lang="scss" scoped>
.num{
    font-size: 26px;
    margin-bottom: 8px;
}
</style>